<template>
  <Layout>
    <header>
      <h3>Share the love! Share a voucher with someone special.</h3>
      <p>Our vouchers are the perfect way to show appreciation and make someone's day brighter.</p>
      <p>Vouchers are redeemable in store and online.</p>
    </header>
    <div v-if="paymentProccessing" class="payment-proccessing">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 150">
        <path
          fill="none"
          stroke="#007bff"
          stroke-width="5"
          stroke-linecap="round"
          stroke-dasharray="300 385"
          stroke-dashoffset="0"
          d="M275 75c0 31-27 50-50 50-58 0-92-100-150-100-28 0-50 22-50 50s23 50 50 50c58 0 92-100 150-100 24 0 50 19 50 50Z">
          <animate attributeName="stroke-dashoffset" calcMode="spline" dur="2" values="685;-685" keySplines="0 0 1 1" repeatCount="indefinite"></animate>
        </path>
      </svg>
      <h2 class="status">{{ status }}</h2>
    </div>
    <div v-if="home" class="voucher-purchase">
      <h2 class="voucher-company">{{ voucher.company.name }}</h2>
      <form class="purchase-form">
        <label for="amount">Voucher Amount</label>
        <input type="number" id="amount" name="amount" min="0" v-model="voucher.amount" required />
        <label for="your-email">Purchaser's Email</label>
        <input type="email" id="your-email" name="your-email" v-model="voucher.purchaserEmail" required />
        <p>This will send the reciept {{ showSomeoneElseSection ? "" : "and digital voucher" }} to the Purchaser's email.</p>
        <div>
          <p>Total includes stripe credit card fee: ${{ stripeTotal }}</p>
        </div>
        <button class="someone-else-button" @click.stop.prevent="toggleSomeoneElseSection">{{ showSomeoneElseSection ? "Send to Purchaser" : "Send As A Gift" }}</button>
        <div v-if="showSomeoneElseSection">
          <p>This will send the digital voucher to the recipient's email.</p>
          <label for="recipient-email">Recipient's Email</label>
          <input type="email" id="recipient-email" name="recipient-email" v-model="voucher.recipientEmail" required />
          <label for="message">Message (optional)</label>
          <textarea id="message" v-model="voucher.message" name="message"></textarea>
        </div>

        <div v-if="errors.length">
          <h3 class="errors" v-for="(error, idx) in errors" :key="idx + error">{{ error }}</h3>
        </div>

        <button type="submit" @click.stop.prevent="submit">Continue to Payment</button>
      </form>
    </div>
    <div v-if="finished" class="payment-finished">
      <h1>Payment Complete</h1>
      <p>Thank you for your payment!</p>
      <p>The voucher & receipt have been sent to your selected emails.</p>
      <p class="button" @click.stop.prevent="goHome">Purchase Another Voucher</p>
      <iframe :src="'https://flaskapi-gpvubq4nta-ts.a.run.app/receipt/' + company + '/' + site + '/' + voucherID" frameborder="0" width="1200" height="880"></iframe>
      <!-- Add your payment complete content here -->
    </div>
    <div class="payment-section">
      <form @submit.prevent="handlePayment" id="payment-form">
        <div id="payment-element">
          <!--Stripe.js injects the Payment Element-->
        </div>
        <button v-if="intentLoaded" id="submit">
          <div class="spinner hidden" id="spinner"></div>
          <span id="button-text">Pay now</span>
        </button>
        <div id="payment-message" class="hidden"></div>
      </form>
    </div>
  </Layout>
</template>

<script>
import { api } from "@/helpers/api";
import { customAlphabet } from "nanoid";
import Layout from "./Layout.vue";

export default {
  name: "VoucherPurchase",
  data() {
    return {
      status: "",
      stripe: null,
      elements: null,
      intentLoaded: false,
      paymentProccessing: false,
      finished: false,
      home: true,
      voucherID: false,
      company: "bagels",
      site: "vouchers",
      voucher: {
        company: false,
        purchaserEmail: "",
        recipientEmail: "",
        message: "",
        amount: 0,
      },
      showSomeoneElseSection: false,
      errors: [],

      alphabet: "1234567890abcdefghijklmnopqrstuvwxyz",
    };
  },
  components: { Layout },
  methods: {
    goHome() {
      location.reload();
    },

    toggleSomeoneElseSection() {
      this.showSomeoneElseSection = !this.showSomeoneElseSection;
    },
    async submit() {
      this.errors = [];
      if (this.voucher.purchaserEmail.length === 0 || this.voucher.amount === 0) {
        this.errors.push("Please enter a purchaser email and amount");
      }
      if (this.showSomeoneElseSection && this.voucher.recipientEmail.length === 0) {
        this.errors.push("Please enter a recipient email");
      }

      let order_data = {
        amount: parseInt(this.stripeTotal * 100), // add 3% for stripe fee
        currency: "nzd",
      };

      if (this.errors.length === 0) {
        let res = await api.getStripeIntent(order_data);
        if (!("error" in res)) {
          this.updateIntent(res.reply);
        } else {
          this.errors.push("There was an error creating the payment intent. Please try again.");
          console.log(res.error);
        }
      }
    },

    updateIntent(clientSecret) {
      const appearance = {
        theme: "stripe",
        variables: {
          colorPrimary: "#77b3e8",
          colorBackground: "#fafaff",
          colorText: "#3B3C36",
        },
      };

      const paymentElementOptions = {
        layout: "tabs",
      };
      this.elements = this.stripe.elements({ appearance, clientSecret });
      this.intentLoaded = true;
      console.log("intent received");
      const paymentElement = this.elements.create("payment", paymentElementOptions);
      paymentElement.mount(document.querySelector("#payment-element"));
    },

    async handlePayment() {
      document.querySelector(".payment-section").style.setProperty("display", "none");
      this.paymentProccessing = true;
      this.status = "Processing Transaction";
      let elements = this.elements;
      // Confirm the payment
      const result = await this.stripe.confirmPayment({
        elements: elements,
        redirect: "if_required",
        confirmParams: {
          return_url: window.location.href,
          receipt_email: this.email,
        },
      });
      if (result.error) {
        console.log(result.error.message);
        this.paymentProccessing = false;
        document.querySelector(".payment-section").style.setProperty("display", "block");
        this.errors.push(result.error.message);
      } else {
        if (result.paymentIntent.status === "succeeded") {
          console.log("payment succeeded");
          this.completeTransaction(result);
        }
      }
    },

    async completeTransaction(result) {
      const nanoid = customAlphabet(this.alphabet, 6);
      let voucher = {
        ID: nanoid(),
        name: this.showSomeoneElseSection ? this.voucher.recipientEmail : this.voucher.purchaserEmail,
        email: this.showSomeoneElseSection ? this.voucher.recipientEmail : this.voucher.purchaserEmail,
        doc_type: "credit",
        value: this.voucher.amount,
        date: new Date().toISOString(),
      };

      let voucher_order = {
        total: result.paymentIntent.amount / 100,
        events: {
          created_at: new Date().toISOString(),
          updated_at: new Date().toISOString(),
        },
        paymentStatus: "paid",
        payments: [
          {
            type: "stripe",
            value: result.paymentIntent.amount / 100,
            stripeID: result.paymentIntent.id,
          },
        ],
        products: [
          {
            name: "Voucher",
            price: this.voucher.amount,
            quantity: 1,
            voucher: voucher.ID,
          },
          {
            name: "Stripe Fee",
            price: this.voucher.amount * 0.03,
            quantity: 1,
          },
        ],
      };

      await api.postVoucher(voucher);

      voucher.msg = this.voucher.message;
      if (this.voucher.recipientEmail) {
        voucher.sender = this.voucher.purchaserEmail;
      }
      await api.emailVoucher(voucher);
      await api.newVoucher(voucher_order).then(async (reply) => {
        console.log(reply);
        reply["email"] = this.voucher.purchaserEmail;
        await api.emailReceipt(reply);
        this.status = "Sending Voucher Receipt";
        this.finished = true;
        this.paymentProccessing = false;
        this.home = false;
        this.voucherID = reply._id;
      });
    },
  },

  async mounted() {
    const stripeKey = process.env.VUE_APP_STRIPE_LIVE;
    // estlint-disable-next-line
    this.stripe = window.Stripe(stripeKey);
    this.stripe.api_version = "2024-04-10";
  },

  async created() {},

  computed: {
    stripeTotal() {
      return this.voucher.amount + this.voucher.amount * 0.03;
    },
  },
};
</script>

<style scoped lang="scss">
a {
  text-decoration: none;
}

header {

  p {
    color: var(--action-colour);
    margin: 0.25rem;
  }

  h3 {
    color: var(--text-colour);
    text-align: center;
    margin: 1rem;
    margin-top: 2rem;
  }
}
.payment-section,
.voucher-purchase,
.payment-finished {
  max-width: 420px;
  margin: 0 auto;
  color: var(--text-colour);
}

.payment-section {
  padding: 0 1rem 2rem;
}

.voucher-purchase,
.payment-finished {
  padding: 1.25rem;
  border-radius: 0.75rem;
  background-color: var(--secondary-colour);
}

.voucher-company {
  margin-top: 0;
}

.purchase-form {
  text-align: left;
}

.payment-section button,
.voucher-purchase button,
.button {
  width: 100%;
  padding: 0.65rem 0.75rem;
  margin-top: 0.75rem;
  background-color: var(--primary-colour);
  color: var(--text-colour);
  border: 1px solid var(--primary-colour);
  border-radius: 0.5rem;
  cursor: pointer;
  transition: background-color 160ms ease;
}

.payment-section button:hover,
.voucher-purchase button:hover,
.button:hover {
  background-color: var(--secondary-colour);
}

.button {
  display: block;
  max-width: 380px;
  margin: 0 auto 2rem;
  text-align: center;
}

.voucher-purchase {
  text-align: center;

  p {
    line-height: 1.5;
  }

  label {
    display: block;
    margin-top: 0.75rem;
    text-align: left;
  }

  input,
  textarea {
    width: 100%;
    padding: 0.65rem;
    margin-top: 0.35rem;
    border: 1px solid var(--primary-colour);
    border-radius: 0.5rem;
    background-color: var(--text-colour);
    color: var(--primary-colour);
  }

  textarea {
    min-height: 6rem;
    resize: vertical;
  }

  .someone-else-button {
    margin-top: 1rem;
    border-color: var(--action-colour);
  }

  .errors {
    color: #ffd3d3;
    text-align: left;
    margin: 0.5rem 0 0;
  }
}

iframe {
  transform: scale(0.5);
  transform-origin: top left;
  width: 750px;
}

.payment-proccessing {
  // height: 100%;
  width: 100vw;
  z-index: 10;
  background-color: rgba(255, 255, 255, 0.75);
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;

  .status {
    color: var(--primary-colour);
  }

  svg {
    width: 15rem;
    margin-top: 15rem;
  }
}

@media only screen and (max-width: 900px) {
  iframe {
    width: 100%;
    height: 520px;
    transform: none;
  }
}
</style>
